import React from 'react'
import { Stack } from 'react-bootstrap'
import type { FormikHelpers } from 'formik/dist/types'
import type { UseEditPersonInfoArgs, VendorInfoFormProps } from '@ztechapps/webui.contract'
import { useEditPersonInformation } from '@ztechapps/customer.webui'
import { Form, FormSaveCancelButtons } from '@ztechapps/webui.form'
import { UserFormValidate } from '@ztechapps/webui.input'
import { HorizontalStack } from '@ztechapps/webui.util'
import { VendorFormLayout } from '@ztechapps/vendor.webui'
import { vendorQueries } from '../../view/purchases/item/graphql'

export const VendorInfoForm = ({ vendor, onSaved, onCancel }: VendorInfoFormProps) => {
  const { onFormSubmit } = useEditPersonInformation({ mutationConfig: vendorQueries.updateConfig })
  const initialValues: UseEditPersonInfoArgs = {
    _id: vendor?._id,
    company: vendor?.company,
    profile: vendor?.profile,
    phone: vendor?.phone,
  }

  // A failed save is toasted by the hook, so nothing runs after it and the form stays as entered.
  const onSubmit = async (values: UseEditPersonInfoArgs, formikHelpers: FormikHelpers<UseEditPersonInfoArgs>) => {
    if (await onFormSubmit(values, formikHelpers)) await onSaved?.()
  }

  return (
    <Form onSubmit={onSubmit} validate={UserFormValidate} initialValues={initialValues} onReset={() => onCancel?.()}>
      <Stack gap={2}>
        <VendorFormLayout />

        <HorizontalStack className="justify-content-end">
          <div>
            <FormSaveCancelButtons />
          </div>
        </HorizontalStack>
      </Stack>
    </Form>
  )
}
